module.exports = __webpack_public_path__ + "img/imagem-da-home-450.a9fb4f27.png";